import { createAsyncThunk } from "@reduxjs/toolkit";

import { ApiRequest, serializeModel } from "../../../api";
import { SiteRequest } from "../../../site";
import { SiteCustomFieldsRequestBody } from "@vviinn/user-managment-client-ts/dist/models/SiteCustomFieldsRequestBody";

export const fetchCustomFields = createAsyncThunk(
  "site/customFields",
  async ({ api, value }: ApiRequest<SiteRequest>) => {
    const { siteId, companyId } = value;
    const response = await api.getSiteCustomFields(companyId, siteId);
    return serializeModel(response.value);
  },
);

export const upsertCustomFields = createAsyncThunk(
  "site/upsertCustomFields",
  async ({
    api,
    value,
  }: ApiRequest<
    SiteRequest & {
      siteCustomFieldsRequestBody?: SiteCustomFieldsRequestBody;
    }
  >) => {
    const { siteId, companyId, siteCustomFieldsRequestBody } = value;
    const response = await api.upsertSiteCustomFieldsDefinition(
      companyId,
      siteId,
      siteCustomFieldsRequestBody,
    );
    return serializeModel(response.value);
  },
);

export const synchronizeSchema = createAsyncThunk(
  "site/synchronize-schema",
  async ({ api, value }: ApiRequest<SiteRequest>) => {
    const { siteId, companyId } = value;
    const response = await api.synchronizeSiteSchema(companyId, siteId);
    return serializeModel(response.value);
  },
);
